<div id="mobile-bar" [ngClass]="isIOS() === true ? 'mobilebar-ios' : ''">
    <!--    <div class="bar-item" routerLink="/dashboard" routerLinkActive="active">-->
    <!--        <i class="ti-home"></i>-->
    <!--    </div>-->

    <div class="bar-item" routerLink="/meals" routerLinkActive="active">
        <i class="ti-home"></i>
    </div>

    <div class="bar-item" (click)="openShoppingListModal()">
        <i class="ti-shopping-cart"></i>
    </div>

    <div class="bar-item bar-plus">
        <i class="mdi mdi-plus-circle" (click)="openShortcutsModal()"></i>
    </div>

    <div class="bar-item" (click)="openRecipesTextModal()">
        <i class="ti-receipt"></i>
    </div>

    <div class="bar-item" routerLink="/settings/profile" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <i class="ti-user"></i>
    </div>
</div>
